import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { Col } from "antd";

import InputItem from "../../../app/generic/inputItem";
import SelectItem from "../../../app/generic/selectItem";
import { setZipCodePattern } from "../../../../modules/consignmentFunctions";

const AddressRow = ({
  form,
  czech,
  pickup,
  onZipChange,
  formItemLayout,
  onCountrySelect,
  selectCountries,
  selectedProduct,
  onAnyValueChange,
  getFieldDecorator,
}) => {
  const intl = useIntl();
  const [prefix] = useState(pickup ? "na" : "vy");
  const [identifier] = useState(pickup ? "pickup" : "delivery");
  const [identifierUpper] = useState(pickup ? "Pickup" : "Delivery");

  const [zipPattern, setZipPattern] = useState(setZipCodePattern("CZ"));
  const handleCountrySelect = useCallback(
    (value) => {
      if (value) {
        const country = selectCountries.find((c) => c.id === value);
        onCountrySelect(country);

        setZipPattern(setZipCodePattern(country.code));
        setTimeout(() => form.validateFields([`${identifier}ZipCode`]), 500);
      }
    },
    [form, identifier, selectCountries, onCountrySelect]
  );

  const handleZipChange = useCallback(
    (e) => {
      onZipChange && onZipChange(e.target && e.target.value);
      onAnyValueChange();
    },
    [onZipChange, onAnyValueChange]
  );

  useEffect(() => {
    selectedProduct &&
      selectedProduct.domestic &&
      setZipPattern(setZipCodePattern("CZ"));
  }, [selectedProduct]);

  const noCountry = useMemo(
    () =>
      !selectedProduct ||
      (selectedProduct &&
        (selectedProduct.code === "ECI" ||
          selectedProduct.code === "SPI" ||
          selectedProduct.code === "ECI_B2C" ||
          selectedProduct.code === "ERI" ||
          selectedProduct.code === "PPI")),
    [selectedProduct]
  );

  return (
    <>
      <Col span={5}>
        <InputItem
          pattern={zipPattern}
          autoComplete="postal-code"
          onChange={handleZipChange}
          formItemLayout={formItemLayout}
          fieldName={`${identifier}ZipCode`}
          getFieldDecorator={getFieldDecorator}
          placeholder={pickup ? "70900" : "11000"}
          label={intl.formatMessage({
            id: `calculator.${identifier}Zip`,
            defaultMessage: `PSČ ${prefix}kládky`,
          })}
          message={intl.formatMessage({
            id: `calculator.empty${identifierUpper}Zip`,
            defaultMessage: `Zadejte prosím PSČ ${prefix}kládky!`,
          })}
        />
      </Col>
      <Col span={7}>
        <SelectItem
          showSearch
          onChange={handleCountrySelect}
          formItemLayout={formItemLayout}
          fieldName={`${identifier}CountryId`}
          getFieldDecorator={getFieldDecorator}
          initialValue={noCountry ? undefined : czech && czech.id}
          label={intl.formatMessage({
            id: `calculator.${identifier}Country`,
            defaultMessage: `Stát ${prefix}kládky`,
          })}
          message={intl.formatMessage({
            id: `calculator.empty${identifierUpper}Country`,
            defaultMessage: `Vyberte prosím stát ${prefix}kládky!`,
          })}
          disabled={!selectedProduct || selectedProduct.domestic}
          options={
            selectCountries &&
            selectCountries.filter((c) =>
              pickup ? c.forPickup : c.forDelivery
            )
          }
        />
      </Col>
    </>
  );
};

export default AddressRow;
